var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"bcx-button orange bcx-button-search",attrs:{"type":"submit","disabled":_vm.isSearchDisabled},on:{"click":_vm.search}},[_vm._v(" "+_vm._s(_vm.$t('buttons.search'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }